// src/components/StyledComponents/Icon.ts
import styled from 'styled-components';
import { MEDIA_BREAKPOINTS} from '@/constants/layout';

interface IconProps {
  $bg?: string;
}

const Icon = styled.div<IconProps>`
  cursor: pointer;
  color: ${({ theme, color }) => color || theme.iconColor};
  display: flex;
  justify-content: center;
  align-items: center;

  & > svg {
    margin-left: 5px;
    border-radius: 50%;
    box-shadow:
      0 4px 6px ${({ theme }) => theme.shadowDarkColor},
      0 1px 3px ${({ theme }) => theme.shadowLightColor};
    transition:
      width 0.3s ease,
      height 0.3s ease;
    background: ${({ $bg, theme }) =>
      $bg ||
      `linear-gradient(
         100deg,
         ${theme.gradientColors[0]},
         ${theme.gradientColors[1]}
       )`};
  }

  @media (max-width: ${MEDIA_BREAKPOINTS.smallScreen}) {
    & > svg {
      width: ${({ theme }) => theme.sizes.small.iconHeight};
      height: ${({ theme }) => theme.sizes.small.iconHeight};
    }
  }

  @media (min-width: ${MEDIA_BREAKPOINTS.smallScreen}) {
    & > svg {
      width: ${({ theme }) => theme.sizes.small.iconHeight};
      height: ${({ theme }) => theme.sizes.small.iconHeight};
    }
  }

  @media (min-width: ${MEDIA_BREAKPOINTS.mediumScreen}) {
    & > svg {
      width: ${({ theme }) => theme.sizes.medium.iconWidth};
      height: ${({ theme }) => theme.sizes.medium.iconHeight};
    }
  }

  @media (min-width: ${MEDIA_BREAKPOINTS.largeScreen}) {
    & > svg {
      width: ${({ theme }) => theme.sizes.large.iconWidth};
      height: ${({ theme }) => theme.sizes.large.iconHeight};
    }
  }
`;

export default Icon;